module.exports = __webpack_public_path__ + "static/media/double-right-blue.7779299a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/double-right-blue.svg
// module id = 3224
// module chunks = 0